import qs from 'qs'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router'
import { requestGetTransactionResult } from '../../api'
import LoadingOverlay from '../common/LoadingOverlay'
import { purchaseResultSelector } from '../libs/selectors'
import PurchaseResultPage from '../purchase/PurchaseResultPage'

const TransactionResultPage = props => {
  const [data, setData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const { search } = useLocation()
  const {
    rec_trade_id: recTradeId,
    order_no: orderNo,
    cream_item_id: creamItemId,
  } = qs.parse(search.slice(1))

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      if (recTradeId && orderNo) {
        const res = await requestGetTransactionResult(recTradeId, orderNo)
        setData(res.data)
      }
      setIsLoading(false)
    }
    fetchData()
  }, [orderNo, recTradeId])

  return isLoading ? (
    <LoadingOverlay />
  ) : (
    <PurchaseResultPage
      purchaseResult={data}
      toPurchaseLoginPage={props.toPurchaseLoginPage}
      creamItemId={creamItemId}
    />
  )
}

export default connect(state => ({
  purchaseResult: purchaseResultSelector(state.tapPay),
}))(TransactionResultPage)
